import { render, staticRenderFns } from "./SendSepaDateCorrectionClaimModal.vue?vue&type=template&id=1d94d01f"
import script from "./SendSepaDateCorrectionClaimModal.vue?vue&type=script&lang=js"
export * from "./SendSepaDateCorrectionClaimModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports